import { BaseStore } from "../stores/base_store"
import { makeAutoObservable } from "mobx"
import CallAPI from "../api/call_api"

export type CallParticipantProps = {
    key: string;
    call: string;

    phone_number: string;
    twilio_call_sid: string;
    twilio_status: string;
    twilio_label: string;
    twilio_muted: string;
    twilio_hold: string;
    twilio_duration: string;
    twilio_conference_sid: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: CallParticipantProps) => void;
};

// Domain object CallParticipant
export class CallParticipant implements CallParticipantProps {
    key = "";
    call = "";

    phone_number = "";
    twilio_call_sid = "";
    twilio_status = "";
    twilio_label = "";
    twilio_muted = "";
    twilio_hold = "";
    twilio_duration = "";
    twilio_conference_sid = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: CallParticipantProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: CallParticipantProps) {
		this.key = attributes.key;
		this.call = attributes.call;
        this.phone_number = attributes.phone_number;
		this.twilio_call_sid = attributes.twilio_call_sid;
        this.twilio_status = attributes.twilio_status;
        this.twilio_label = attributes.twilio_label;
        this.twilio_muted = attributes.twilio_muted;
        this.twilio_hold = attributes.twilio_hold;
        this.twilio_duration = attributes.twilio_duration;
        this.twilio_conference_sid = attributes.twilio_conference_sid;
        this.date_created = attributes.date_created;
        this.date_updated = attributes.date_updated;
    }

}


export class CallParticipantStore extends BaseStore<CallParticipantProps, CallParticipant> {
    FETCHED_ITEMS = [] as string[];

    async fetchParticipants(callKey: string, identityKey: string, cursor = "") {
        const key = callKey + '-' + identityKey;
        if(this.FETCHED_ITEMS.includes(key))
            return null;
        this.FETCHED_ITEMS.push(key);

        return CallAPI.fetchParticipants(callKey, identityKey, cursor)
            .then((resp) => {
                this.receiveUpdate(resp.items);
                if (resp.cursor) {
                    this.fetchParticipants(callKey, identityKey, resp.cursor);
                }
                return resp.items;
            });
    }


    modelConstructor() {
        return CallParticipant;
    }

}
